<div class="transaction-list">
  @if (transactions?.length > 0) {
    <div>
      @for (record of transactions; track getTrackKey(record)) {
        <div
          class="flex justify-between w-full items-center p-2 md:px-4 mb-4 md:mb-6 lg:mb-6 transaction transition-all duration-300 linear"
          [class.transaction--clickable]="canOpenDetails(record)"
          [class.transaction--highlighted]="isHighlighted(record)"
          (click)="onRecordClick(record)"
        >
          <div
            class="flex mr-4 items-center justify-center p-1 min-w-8 min-h-8 md:min-w-10 md:min-h-10 rounded-lg image transaction-logo"
          >
            @if (isPurchase(record)) {
              @if (record.purchase?.product) {
                <img [src]="record.purchase?.product?.categories?.[0]?.image" [alt]="" class="max-w-full h-auto" />
              } @else {
                <img src="assets/img/balance/leave.svg" alt="" class="max-w-full h-auto" />
              }
            } @else if (isTransfer(record)) {
              <img src="assets/img/balance/leave.svg" alt="" class="max-w-full h-auto" />
            } @else if (isDeposit(record)) {
              <img src="assets/img/balance/deposit.svg" alt="" class="max-w-full h-auto" />
            } @else {
              <img src="assets/img/balance/leave.svg" alt="" class="max-w-full h-auto" />
            }
          </div>
          <div class="w-full overflow-hidden flex justify-start items-center">
            <div class="left w-1/2 flex flex-1 flex-col">
              @if (isReimburse(record)) {
                <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                  {{ currentLang === 'en' ? record?.name_en : record?.name_es }}
                </span>
              } @else if (isPurchase(record)) {
                @if (record?.purchase?.product) {
                  <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                    {{ record?.purchase?.product?.name }}
                  </span>
                } @else {
                  <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                    {{ currentLang === 'en' ? record?.name_en : record?.name_es }}
                  </span>
                }
              } @else if (isTransfer(record)) {
                @if (isAmountPositive(record)) {
                  <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                    {{ 'balance.transferFrom' | translate }} {{ record?.counterpart?.full_name }}
                  </span>
                }
                @if (isAmountNegative(record)) {
                  <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                    {{ 'balance.transferTo' | translate }} {{ record?.counterpart?.full_name }}
                  </span>
                }
              } @else if (isDeposit(record)) {
                @let localizedTitle = currentLang === 'en' ? record?.name_en : record?.name_es;
                @let depositTitle = localizedTitle?.trim() || record?.transaction_title?.trim();
                <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                  {{ depositTitle || ('balance.ganasEarned' | translate) }}
                </span>
              } @else {
                <span class="text-base md:text-lg lg:text-lg outfit font-bold truncate-text">
                  {{ currentLang === 'en' ? record?.name_en : record?.name_es }}
                </span>
              }
              <span class="sm-font-size-13 md:text-lg lg:text-lg outfit font-light">
                {{ record.status_display }}
              </span>
            </div>
            <div class="right w-1/2 flex-1 flex flex-col justify-end items-end">
              <span
                class="block justify-end self-end float-right text-base md:text-lg outfit font-bold"
                [class.green]="isTransactionAmountCredit(record)"
                [class.red]="isTransactionAmountDebit(record)"
              >
                {{ record.amount_display }}
              </span>
              <span class="sm-font-size-13 md:text-lg outfit font-light">
                {{ getTransactionDisplayDate(record) }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
